const Footer = () => {
    return (
        <footer className="w-full bg-gray-900 text-white py-8 text-center">
            <p className="text-sm">&copy; 2025 HIKEHEALTH GS . All Rights Reserved..</p>
        </footer>
    );
};

export default Footer;
